import ContentContainer from "@/src/components/containers/ContentContainer";
import GenericHead from "@/src/components/Head/GenericHead";

const AboutPage = () => {
  return (
    <>
      <GenericHead title={"About Supercoach playbook"} />
      <div className="bg-white">
        <ContentContainer bgColor="white">
          <div className={"flex flex-col gap-4 py-4 bg-white 123"}>
            <h1>Advertise With Us</h1>
            <p>Are you interested in jumping onboard with SC Playbook?</p>
            <p>
              Advertise through SC Playbook via our multitude of channels to
              promote your business to our rapidly expanding audience of
              passionate sporting fans.{" "}
            </p>
            <p>
              Whether you&#39;re looking at scattering your brand across all our
              sports across an entire year, or simply plugging a one-off ad into
              a podcast, we&#39;ve got you covered with a whole range of tiered
              sponsorship packages.
            </p>
            <p>
              <b>What we can offer:</b>
            </p>
            <ul className="list-disc">
              <li>Organic podcast reads</li>
              <li>Podcast appearances</li>
              <li>
                In-article advertising: Customised graphics, written sell,
                hyperlinks, banners
              </li>
              <li>
                Social posting to over 60,000 followers across our dedicated
                Facebook, Twitter, Tiktok, Instagram and YouTube channels
              </li>
              <li>Video content creation</li>
            </ul>
            <p>
              After more? We&#39;re entirely flexible in providing you with the
              exact types of marketing you&#39;re after, tailored to your
              specific goals.
            </p>
            <p>
              {" "}
              Get in touch via our email at{" "}
              <a href="email:supercoachplaybook@gmail.com">
                supercoachplaybook@gmail.com
              </a>{" "}
              to discuss your partnership with SC Playbook.
            </p>
          </div>
        </ContentContainer>
      </div>
    </>
  );
};

export default AboutPage;
